import styled from '@emotion/styled'
import {getI18n} from 'react-i18next'

const PlainText = styled.div`
  font-family: Inter;
  font-weight: 400;
  font-size: 14px;
  line-height: 22px;
  letter-spacing: 0%;
  color: #666565;
`

const ArabicText = styled.div`
  font-family: Inter;
  font-weight: 400;
  font-size: 14px;
  line-height: 22px;
  letter-spacing: 0%;
  text-align: right;
  margin-top: 2rem;
`

const Table = styled.table`
  border: solid 1px #a6a6a6;
  border-collapse: collapse;
  width: 100%;

  & td {
    border: solid 1px #a6a6a6;
    height: 42px;
    text-align: center;
  }

  & th {
    border: solid 1px #a6a6a6;
    border-collapse: collapse;
    color: #666565;
    font-family: Roboto;
    font-weight: 700;
    font-size: 14px;
    line-height: 22px;
    letter-spacing: 0%;
    height: 42px;
  }
`

const Container = styled.div`
  display: flex;
`

export const SyrianStub = () => {
  const {language} = getI18n()
  return (
    <Container style={{flexDirection: language === 'ar' ? 'column-reverse' : 'column'}}>
      {language !== 'ar' && (
        <PlainText>
          <p>
            In order to make a deposit, please transfer your deposit amount to the following wallet
            address below.
          </p>
          <p>
            The amount will be credited to your account shortly. Please note that withdrawals will
            also be processed via the same method. If you need any assistance, our support team is
            available at any time.
          </p>
        </PlainText>
      )}
      <Table>
        <tbody>
          <tr>
            <th>NETWORK</th>
            <th>Wallet Address</th>
          </tr>
          <tr>
            <td>BTC</td>
            <td>bc1qgq3vcrnpj9pvmqg8rwhy97tjahx3hj9fgtl99a</td>
          </tr>
          <tr>
            <td>ETH</td>
            <td>0xac37734D5CD718a8cCF4fD8B5567DC9C9b95Edf1</td>
          </tr>
          <tr>
            <td>USDT TRC</td>
            <td>TM51hxPwcX3s4w6e4FRUMBA7gaaZS2zruA</td>
          </tr>
          <tr>
            <td>USDT ERC</td>
            <td>0xac37734D5CD718a8cCF4fD8B5567DC9C9b95Edf1</td>
          </tr>
          <tr>
            <td>USDT BEP20 (Binance Smart Chain)</td>
            <td>0xac37734D5CD718a8cCF4fD8B5567DC9C9b95Edf1</td>
          </tr>
        </tbody>
      </Table>
      <ArabicText>
        لإجراء الإيداع، يرجى تحويل المبلغ المراد إيداعه بعملة إلى عنوان المحفظة التالي سيتم إضافة
        المبلغ إلى حسابك قريبًا. يرجى ملاحظة أن عمليات السحب ستتم أيضًا باستخدام نفس الطريقة. إذا
        كنت بحاجة إلى أي مساعدة، فإن فريق الدعم لدينا متوفر في أي وقت.
      </ArabicText>
    </Container>
  )
}
